export default "__VITE_ASSET__MA9LPyyh__"